import { render, staticRenderFns } from "./MiraDataQuality.vue?vue&type=template&id=40db88db&scoped=true&"
import script from "./MiraDataQuality.vue?vue&type=script&lang=ts&"
export * from "./MiraDataQuality.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDataQuality.vue?vue&type=style&index=0&id=40db88db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db88db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
